import { useMutation } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import reactQueryUtils from "../../../utils/reactQueryUtils";
import actionService from "../../services/actionService";

const { client } = reactQueryUtils;

const useBulkUpdateActions = () =>
    useMutation(actionService.bulkUpdate, {
        onSuccess: () => {
            client.invalidateQueries({ queryKey: [queryKeys.currentActions] });
            client.invalidateQueries({ queryKey: [queryKeys.riskAssessmentHistory] });
            client.invalidateQueries({ queryKey: [queryKeys.riskAssessment] });
        },
    });

export default useBulkUpdateActions;
